// extracted by mini-css-extract-plugin
export default {"map":"changeStylesOnPages_map__HeXCl","mapRouteDetails":"changeStylesOnPages_mapRouteDetails__EIk90"};